<script>
  export let idUnico = 'saibamais-1';
  export let content;

  let indexBegin;
  let indexEnd;
  let anchorUrl;

  indexBegin = content.search('{');
  indexEnd = content.search('}');

  do {
    indexBegin = content.search('{{');
    indexEnd = content.search('}}');
    if (indexBegin != -1 && indexEnd != -1) {
      anchorUrl = content.substring(indexBegin + 2, indexEnd);

      anchorUrl = anchorUrl.split('==');

      content = content.replace(
        content.substring(indexBegin, indexEnd + 2),
        '<a class="anchor" target="_blank" href="' +
          anchorUrl[1].trim() +
          '">' +
          anchorUrl[0].trim() +
          '</a>'
      );
    }
  } while (indexBegin != -1 && indexEnd != -1);
</script>

<div class="container" id={idUnico}>
  <div class="icon-wrapper">
    <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_529_3626"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="41"
        height="41"
      >
        <path
          d="M0.429113 14.46C-2.14089 27.85 7.18911 37.57 18.8991 39.82C30.6091 42.07 39.3691 37.14 40.4691 31.4C42.3791 21.45 32.0291 19.81 30.5691 10.66C29.6391 4.83 22.5191 0 15.3491 0C8.91911 0 2.44911 3.9 0.419113 14.46"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_529_3626)">
        <path
          d="M41.3125 -0.378906H-0.6875V40.6211H41.3125V-0.378906Z"
          fill="url(#paint0_linear_529_3626)"
        />
        <path
          d="M28.1647 17.4323H23.8147C23.3647 17.4323 23.0047 17.0723 23.0047 16.6223V12.2723C23.0047 11.6623 22.5047 11.1523 21.8847 11.1523H15.4647C14.8547 11.1523 14.3447 11.6523 14.3447 12.2723V16.6223C14.3447 17.0723 13.9847 17.4323 13.5347 17.4323H9.17469C8.56469 17.4323 8.05469 17.9323 8.05469 18.5523V24.9723C8.05469 25.5823 8.55469 26.0923 9.17469 26.0923H13.5347C13.9847 26.0923 14.3447 26.4523 14.3447 26.9023V31.2523C14.3447 31.8623 14.8447 32.3723 15.4647 32.3723H21.8847C22.4947 32.3723 23.0047 31.8723 23.0047 31.2523V26.9023C23.0047 26.4523 23.3647 26.0923 23.8147 26.0923H28.1647C28.7747 26.0923 29.2847 25.5923 29.2847 24.9723V18.5523C29.2847 17.9423 28.7847 17.4323 28.1647 17.4323Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_529_3626"
          x1="-2.82514"
          y1="20.7544"
          x2="35.5805"
          y2="20.7544"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#236962" />
          <stop offset="1" stop-color="#4DB4AA" />
        </linearGradient>
      </defs>
    </svg>
  </div>
  <div class="titulo">
    <h2><i>SAIBA <b>MAIS</b></i></h2>
  </div>

  <div class="box-texto">
    <p>
      <!-- <slot /> -->
      {@html content}
    </p>
  </div>
</div>

<style>
  .container {
    --Gradientes-Degrad-principal: linear-gradient(
      to right,
      var(--COR_MOD_TER),
      var(--COR_MOD_PRI)
    );
    --Gradientes-Degrad-principal-inv: linear-gradient(
      to left,
      var(--COR_MOD_TER),
      var(--COR_MOD_PRI)
    );
    --Principais-Texto: var(--COR_FONTE);
    --cor-primaria: var(--COR_MOD_PRI);
    --cor-secundaria: var(--COR_MOD_TER);
    --Infogrficos-Cinza: #e1e4e5;

    position: relative;
    /* margin-top: 30px; */
    /*margin-bottom: 30px;*/
    padding-top: 16px;
  }

  :global(a.anchor) {
    color: blue;
    /* #4DB4AA cor correta sharepoint */
    font-weight: 600;
    text-decoration: underline;
    word-break: normal;
  }
  :global(a.anchor:hover) {
    color: blue;
  }
  .icon-wrapper {
    position: absolute;
    top: 0;
    left: -23px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper svg {
    width: 68px;
    height: 68px;
    filter: drop-shadow(0 0 3px #00000044);
  }

  .box-texto {
    width: 100%;
    height: auto;

    color: var(--Principais-Texto);
    font-family: 'Inter';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 26px;

    border-radius: 0 35px 35px 35px;
    padding: 40px 35px 20px 45px;
    white-space: pre-wrap;
    word-break: break-word;
    /* transform: translateY(-1px); */

    border: 2px solid #35766f;
    background-color: #dbf0ee;

    background-origin: border-box;
    background-clip: padding-box, border-box;
  }
  .titulo {
    width: fit-content;
    background: linear-gradient(90deg, #277069, #33867e, #47aba2);
    padding: 6px 15px 6px 50px;
    border-radius: 12.7px 20px 20px 0px;
  }

  .titulo h2 {
    font-family: var(--FONT_ARCHI);
    width: fit-content;
    color: white;
    margin: 0 !important;
    font-weight: 400;
    font-size: 24px;
  }

  .titulo h2 b {
    /* letter-spacing: -4px; */
  }

  .box-texto :global(.gap) {
    height: 15px;
  }

  .box-texto p :global(ul) {
    margin-left: -1.5rem;
  }
  .box-texto p :global(ul li) {
    font-weight: 400;
    padding-left: 15px;
    color: var(--COR_FONTE);
    margin-bottom: 1rem;
  }

  .box-texto p :global(ul li::marker) {
    content: '\f054';
    color: var(--MARROM);
    font-family: 'Font Awesome 6 Free';
    font-weight: 700;
    font-size: 16px;
  }

  @media (max-width: 800px) {
    .icon-wrapper {
      top: -10px;
      transform: translateY(0px);
      left: 10px;
    }

    .icon-wrapper svg {
      width: 60px;
      height: unset;
      filter: drop-shadow(0 0 3px #00000044);
    }
    .titulo {
      padding: 7px 25px 6px 70px;
      border-radius: 20px 20px 20px 0px;
    }
    .box-texto {
      padding: 20px 15px 15px 15px;
      border-radius: 0 15px 15px 15px;
    }
    .box-texto p {
      line-height: 1.4;
    }
  }
</style>
